import classNames from 'classnames'
import * as styles from './empty-composition-bar.css'
import type { SegmentsBarSize } from './segments-bar'

// The empty bar stands in for a SegmentsBar, so it offers the same heights.
type EmptyBarSize = SegmentsBarSize

type EmptyBarProps = {
  ariaLabel: string
  size?: EmptyBarSize
}

export const EmptyCompositionBar: React.FC<EmptyBarProps> = ({ ariaLabel, size = 'tiny' }) => {
  return <div className={classNames(styles.base, styles.baseSize[size])} role="status" aria-label={ariaLabel} />
}
